import styled from 'styled-components';

import PrebookingFilters from './component';

export default styled(PrebookingFilters)`
  width: 100%;
  background: var(--primary-filters);
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 8px;

  .filter {
    margin-right: 16px;
  }

  .DayPickerInput {
    width: 100%;
    input {
      height: 32px;
      padding: 0 8px;
      width: 100%;
    }
  }

  .forecast {
    color: #fff;
    display: flex;
    > div {
      margin-right: 24px;
      > span:first-child {
        margin-right: 8px;
      }
    }
  }
`;
